import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4fce68ce")

_pushScopeId("data-v-4fce68ce")
const _hoisted_1 = { class: "main mypage" }
const _hoisted_2 = { class: "my-page__top" }
const _hoisted_3 = { class: "top__section" }
const _hoisted_4 = { class: "my-page__context" }
const _hoisted_5 = { class: "my-page__context__container" }
const _hoisted_6 = { class: "my-page__profile" }
const _hoisted_7 = {
  key: 0,
  class: "my-page__profile__img"
}
const _hoisted_8 = { class: "my-page__profile__names" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "email" }
const _hoisted_11 = { class: "my-page__thumbnails" }
const _hoisted_12 = {
  key: 0,
  class: "my-page__thumbnail"
}
const _hoisted_13 = { class: "my-page__thumbnail--title" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "label" }, " ", -1)
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "my-page__thumbnail--history" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "value -bold" }
const _hoisted_20 = { class: "value -bold" }
const _hoisted_21 = { class: "my-page__thumbnail--complete" }
const _hoisted_22 = { class: "label" }
const _hoisted_23 = { class: "value -bold" }
const _hoisted_24 = { class: "value -bold" }
const _hoisted_25 = {
  key: 1,
  class: "my-page__thumbnail"
}
const _hoisted_26 = { class: "my-page__thumbnail--mydoctor" }
const _hoisted_27 = { class: "label" }
const _hoisted_28 = { class: "value -bold" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "value -bold" }, " ", -1)
const _hoisted_30 = { class: "my-page__nav -regular" }
const _hoisted_31 = { class: "main__section my-page" }
const _hoisted_32 = { class: "my-page__context" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_router_view = _resolveComponent("router-view")
  const _directive_Account = _resolveDirective("Account")

  return _withDirectives((_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("section", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              (_ctx.isValidUserProfile)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode("img", { src: _ctx.userPicture }, null, 8, ["src"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_8, [
                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.accountInfo.name), 1),
                _createVNode("span", _hoisted_10, _toDisplayString(_ctx.accountInfo.email), 1)
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              (_ctx.summary.isLoading)
                ? (_openBlock(), _createBlock("ul", _hoisted_12, [
                    _createVNode("li", _hoisted_13, [
                      _hoisted_14,
                      _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t('face-to-face cooperation')), 1),
                      _createVNode("span", _hoisted_16, _toDisplayString(_ctx.t('second opinion')), 1)
                    ]),
                    _createVNode("li", _hoisted_17, [
                      _createVNode("span", _hoisted_18, _toDisplayString(_ctx.t('requested count')), 1),
                      _createVNode("span", _hoisted_19, _toDisplayString(_ctx.ServiceCount.onlineCare.request), 1),
                      _createVNode("span", _hoisted_20, _toDisplayString(_ctx.ServiceCount.secondOpinion.request), 1)
                    ]),
                    _createVNode("li", _hoisted_21, [
                      _createVNode("span", _hoisted_22, _toDisplayString(_ctx.t('respond count')), 1),
                      _createVNode("span", _hoisted_23, _toDisplayString(_ctx.ServiceCount.onlineCare.response), 1),
                      _createVNode("span", _hoisted_24, _toDisplayString(_ctx.ServiceCount.secondOpinion.response), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.summary.isLoading)
                ? (_openBlock(), _createBlock("ul", _hoisted_25, [
                    _createVNode("li", _hoisted_26, [
                      _createVNode("span", _hoisted_27, _toDisplayString(_ctx.t('my doctors')), 1),
                      _createVNode("span", _hoisted_28, _toDisplayString(_ctx.DoctorCount), 1),
                      _hoisted_29
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("nav", _hoisted_30, [
            _createVNode("div", null, [
              _createVNode(_component_router_link, {
                class: "my-page--link",
                to: _ctx.path.Profile
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('edit personal information')), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_router_link, {
                class: "my-page--link",
                to: _ctx.path.Password
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('change password')), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              (_ctx.isPaid.value)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: _ctx.path.OrderList,
                    class: 
                  _ctx.isActive('/mypage/orderlist')
                    ? 'router-link-active router-link-exact-active my-page--link'
                    : 'my-page--link'
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('paid history')) + " dddd ", 1)
                    ]),
                    _: 1
                  }, 8, ["to", "class"]))
                : _createCommentVNode("", true),
              _createVNode(_component_router_link, {
                class: "my-page--link",
                to: _ctx.path.MyDoctor
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('my doctors')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("section", _hoisted_31, [
      _createVNode("div", _hoisted_32, [
        _createVNode(_component_router_view)
      ])
    ])
  ], 512)), [
    [_directive_Account]
  ])
})